export default "__VITE_ASSET__CJEJ$U0N__"